import { Link, useLocation, useParams } from "react-router-dom";
import { toast, Toaster } from "react-hot-toast";

import "./Blog.css";


import leafright from "../../Assets/Icons/leafright.png";
import elipseHeading from "../../Assets/Icons/elipse-heading.png";

import { useFormik } from "formik";
import * as yup from "yup";

import { Pagination, Stack } from "@mui/material";

import { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";

import config from "../../Admin/Config.json";
import { GetUserBlogApi } from "../../Admin/callApi/blog";
import {
  GetPublishedBlogCommentApi,
  PostBlogCommentApi,
} from "../../Admin/callApi/blogComment";
import { setLoading } from "../../Redux/action";
import { useDispatch } from "react-redux";
import { showAuth } from "../../Redux/action";


export default function Blog({ post }) {


  const {permalink} = useParams();

  const [postData, setPostData] = useState([]);
  const [recentPosts, setRecentPosts]=useState([])

  const location = useLocation();
  const dispatch = useDispatch();
 
  useEffect(() => {
    if(permalink){
      
      GetUserBlogApi('blog/' + permalink).then((res)=>{
        dispatch(setLoading(true));
        setPostData(res)
        dispatch(setLoading(false));
      })
    }else{

      GetUserBlogApi('blog').then((res) => {
        dispatch(setLoading(true));
        setPostData(res)
        dispatch(setLoading(false));
        
      });
    }
    GetUserBlogApi('blog').then((res)=>{
      dispatch(setLoading(true));
      setRecentPosts(res);
      dispatch(setLoading(false));
    })

  }, [location,permalink]);

  //pagination logic
  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, postData?.length);
  const currentItems =
    postData?.length == 0
      ? ""
      : postData?.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(postData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className="blog">
      <img src={leafright} className="main-leaf" />
      {!post ? (
        <div className="blog-heading">
          <h3  style={{fontWeight:'400'}}>
            Blog
            <img
              src={elipseHeading}
              alt="heading circle"
              style={{ position: "absolute ", left: "3rem", zIndex: "-2" }}
            />
          </h3>
        </div>
      ) : (
        <div style={{ display: "none" }}></div>
      )}

      {postData?.length > 0 ? (
        !post ? (
          <div className="blog-item">
            <div className="blog-cards">
              {currentItems.map(
                ({ feature_image, title, description, permalink }) => (
                  <Link to={`/blog/${permalink}`} className="read-more-link ">
                    <div className="blog-card">
                      <img
                        src={config.awsMediaPath + feature_image}
                        alt={title}
                        className="item-image"
                      />
                      <div className="blog-card-text">
                        <h2 className="blog-card-heading" style={{fontWeight:'400'}}>{title}</h2>
                        <p className="blog-card-desc">{description}</p>
                      </div>
                    </div>
                  </Link>
                )
              )}
            </div>
            <div className="pagination-container">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  boundaryCount={2}
                  siblingCount={0}
                />
              </Stack>
            </div>
          </div>
        ) : (
          <div className="single-blog-container">
            {postData && postData[0] && (
              <div className="single-blog-content">
                <h1 className="single-blog-heading">{postData[0].title}</h1>
                <p className="single-blog-desc">{postData[0].description}</p>
                <img
                  className="single-blog-image"
                  src={config.awsMediaPath + postData[0].feature_image}
                  alt={postData[0].title}
                />
                <div className="single-blog-content">
                  {ReactHtmlParser(postData[0].content)}
                </div>
                <Comment id={postData[0]._id} params={postData[0].permalink} location/>
              </div>
            )}
          </div>
        )
      ) : (
        <div>
          <p style={{ textAlign: "center" }}>No records found</p>
        </div>
      )}
      {recentPosts?.length > 0 ? (
        <div className="blog-container">
          <h2  style={{fontWeight:'400'}}>
            Recent Posts
            <img
              src={elipseHeading}
              alt="heading circle"
              className="recent-circle"
            />
          </h2>
          <div className="blog-preview">
            {recentPosts &&
              recentPosts.map((items, index) => (
                <>
                  {index < 5 && (
                    <Link
                      to={`/blog/${items.permalink}`}
                      className="preview-link"
                    >
                      <div className="single-preview-card">
                        <img
                          src={config.awsMediaPath + items.feature_image}
                          alt={items.title}
                          className="preview-image"
                        />
                        <p className="blog-card-desc">{items.title}</p>
                      </div>
                    </Link>
                  )}
                </>
              ))}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}


const Comment = ({ id, params }) => {
  const notify = () => toast.success("Thanks for review...");
  const notifyError = () => toast.warning("Error commenting");
  const erroress = () => toast.error("Please Login.");
  const [showComment, setShowComment] = useState([]);
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userid = userData ? userData.id : null;
  const email = userData ? userData.email : null;
  const initialValues = {
    firstname: "",
    message: "",
  };
  const validationSchema = yup.object({
    firstname: yup.string().required("Please enter your name"),
    message: yup.string().required("Please enter your message"),
  });
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      if (!userid) {
        erroress();
        dispatch(showAuth(true));
        return;
      }
      try {
        dispatch(setLoading(true));
        await PostBlogCommentApi({
          permalink: params,
          blogID: id,
          CustomerId: userid,
          email: email,
          ...values,
        });
        dispatch(setLoading(false));
        notify();
        formik.resetForm(); // Manually resetting the form
      } catch (error) {
        dispatch(setLoading(false));
        notifyError();
        console.error("Error posting comment:", error);
      }
    },
  });

  useEffect(() => {
    try {
      GetPublishedBlogCommentApi("PublishedblogComment/" + id).then((res) => {
        setShowComment(res);
      });
    } catch {
      toast.error("Error fetching data");
    }
  }, [id]);


  return (
    <div className="comments">
      <form onSubmit={formik.handleSubmit}>
        <div className="comment-fields">
          <input
            type="text"
            placeholder="Enter your name..."
            name="firstname"
            className="comment-name"
            onChange={formik.handleChange}
            value={formik.values.firstname}
          />
          {formik.errors.firstname && <div className="err last">{formik.errors.firstname}</div>}
          <textarea
            placeholder="Message..."
            rows={3}
            cols={10}
            className="comment-message"
            name="message"
            onChange={formik.handleChange}
            value={formik.values.message}
          />
          {formik.errors.message && <div className="err last">{formik.errors.message}</div>}
          <button type="submit" className="submit-comment">
            Submit
          </button>
        </div>
      </form>
      <div>
        {showComment?.length > 0
          ? showComment.map((item, index) => (
              <div key={index} className="blog-comment-for-single">
                <h1>{item.firstname}</h1>
                <p>{item.message}</p>
                <p>Date: {item.date}</p>
              </div>
            ))
          : ""}
      </div>
    </div>
  );
};